import { useAuth } from "context/AuthContext";
import { userRoute } from "pages/user/user.routes";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { InstructorCarousel } from "ui/base/Instructor/InstructorCarousel";
import { mediaSizes, maxContainerWidth } from "ui/theme";
import BackgroundSection from "./BackgroundSection";

const OPTIONS = { align: "start", dragFree: true, duration: 40 };
const SLIDES = Array.from({ length: 10 });

export const BestInstructors = ({ bestInstructors }) => {
  const { userData } = useAuth();
  const navigate = useNavigate();

  const instructors = bestInstructors?.filter(
    (item) => item.user?.id !== userData?.id,
  );

  return (
    <BackgroundSection bgColor="#F7F5F1">
      <Container>
        <InstructorCarousel
          title="Best Instructors"
          slides={instructors || SLIDES}
          options={OPTIONS}
          onSlideClick={(id) => navigate(userRoute.classDetail + id)}
        />
      </Container>
    </BackgroundSection>
  );
};
const Container = styled.div`
  width: 100%;
  --carousel-controls-pr: 1rem;

  @media (width >= ${mediaSizes.md}) {
    --carousel-controls-pr: calc(2rem + max(0px, (100vw - ${maxContainerWidth}) / 2));
  }
`;
